import { useEffect } from 'react';
import { useTripFilters, useSetTripFilters } from '@koob/trip-designer';
import { useActiveFolder } from 'store';

// Bind the global active client folder into the trip filters so Trip Designer
// reads the folder from the store (US-016). Re-binds whenever the active
// folder identity changes (openFolder / refreshFolder), keeping it current.
// No-op when there is no active folder, so Trip Designer stays reachable and
// the existing create-default-folder flow is preserved.
// Skipped once a real trip is loaded (tripId set) — its folder stays pinned.
// Moved out of the deleted trip designer context provider (US-051); mounted
// once in the
// compose shell (Compose/index.js) rather than at the app root.
export const useBindActiveFolder = () => {
  const tripFilters = useTripFilters();
  const setTripFilters = useSetTripFilters();
  const storeActiveFolder = useActiveFolder();

  useEffect(() => {
    if (!storeActiveFolder?.id) {
      return;
    }
    setTripFilters(current => {
      if (current?.tripId) {
        return current;
      }
      if (current?.clientFolder === storeActiveFolder) {
        return current;
      }
      return { ...(current ?? {}), clientFolder: storeActiveFolder };
    });
    // tripFilters is a dep so resetContext() (tripFilters -> null) re-runs
    // this and re-binds the active folder right away; otherwise the next
    // trip silently creates a default folder instead. The identity guard
    // above keeps this a no-op once already bound, so no render loop.
  }, [storeActiveFolder, tripFilters, setTripFilters]);
};
